<!--
  Shown while the router is fetching a lazy route's chunk. Without it, clicking something that
  navigates to a lazily loaded page looks like the app has frozen while the chunk downloads.
  It only appears once a navigation is genuinely slow, so quick in-app moves never flash it.

  The primary line names the destination (the router knows it), so the user can see their click
  landed on the thing they clicked. The secondary line advances while the wait continues.
-->
@if (navigating) {
  <div class="ss-nav-loader" role="status" aria-live="polite">
    <div class="ss-nav-loader__bar"></div>
    <div class="ss-nav-loader__panel">
      <div class="ss-nav-loader__dots"><i></i><i></i><i></i></div>
      <div class="ss-nav-loader__label">{{ navLabel }}</div>
      <div class="ss-nav-loader__stage">{{ navStage }}</div>
    </div>
  </div>
}
<router-outlet></router-outlet>
